// Generated by CoffeeScript 2.7.0
// ==============================================================================
// MODULES - COMPONENTS - CAROUSEL
// ==============================================================================
import $ from "jquery";

$(function() {
  // Use slick in order to implement carousel elements
  $('#JS--carousel').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: false
        }
      }
    ]
  });
  // Delay to display carousel
  return $('#JS--carousel').delay(800).queue(function() {
    return $(this).addClass('do_show').dequeue();
  });
});
